import { Reducer } from 'redux'
import { BusinessVerificationStatus } from '~/types'
import {
  ActionTypes,
  LANDING_PAGE_ACTIONS,
  BusinessAccount,
  Transaction,
  CorporateAccount,
  ManagedAccount,
  TransferInfo,
  DashboardBanner,
} from './types'

const initialState = {
  // user related fields, currently getting from API_V3_USER
  name: '',
  verificationStatus: null,

  // business account related fields
  businessAccount: null,
  latestBusinessTransactions: null,
  merchantBusinessVerifyStatus: null,

  // coporate account related fields
  corporateAccount: null,

  // managed account related fields
  managedAccounts: null,

  // misc
  businessVerificationStatus: null,

  isErc20Enabled: true,
  isZrc2Enabled: true,
  isZrc2NoticeBannerVisible: false,
  isLongerProcessingNoticeBannerVisible: false,
  isVAEnabled: false,
  transferInfo: {
    recipientName: '',
    recipientBankName: '',
    recipientAccountNo: '',
    referenceNumber: '',
    expiredDate: '',
  },

  isDashboardBannerManagementEnabled: false,
  dashboardBanners: [],
}

type State = {
  name: string
  verificationStatus: 'initial' | 'verified' | 'pending' | 'rejected' | null

  businessAccount: BusinessAccount | null
  latestBusinessTransactions: Transaction[] | null
  merchantBusinessVerifyStatus: string | null

  corporateAccount: CorporateAccount | null

  managedAccounts: ManagedAccount[] | null

  businessVerificationStatus: BusinessVerificationStatus | null

  isErc20Enabled: boolean
  isZrc2Enabled: boolean
  isZrc2NoticeBannerVisible: boolean
  isLongerProcessingNoticeBannerVisible: boolean
  isVAEnabled: boolean
  transferInfo: TransferInfo

  isDashboardBannerManagementEnabled: boolean
  dashboardBanners: DashboardBanner[]
}

export const landingPage: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case LANDING_PAGE_ACTIONS.SET_USER_INFO: {
      return {
        ...state,
        name: action.name,
        verificationStatus: action.verificationStatus,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_BUSINESS_ACCOUNT: {
      return {
        ...state,
        businessAccount: action.businessAccount,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_LATEST_BUSINESS_TRANSACTIONS: {
      return {
        ...state,
        latestBusinessTransactions: action.latestBusinessTransactions,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_CORPORATE_ACCOUNT: {
      return {
        ...state,
        corporateAccount: action.corporateAccount,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_MANAGED_ACCOUNTS: {
      return {
        ...state,
        managedAccounts: action.managedAccounts,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_BUSINESS_VERIFICATION_STATUS: {
      return {
        ...state,
        businessVerificationStatus: action.businessVerificationStatus,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ERC20_ENABLED: {
      return {
        ...state,
        isErc20Enabled: action.isErc20Enabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ZRC2_ENABLED: {
      return {
        ...state,
        isZrc2Enabled: action.isZrc2Enabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_ZRC2_NOTICE_BANNER_VISIBLE: {
      return {
        ...state,
        isZrc2NoticeBannerVisible: action.isZrc2NoticeBannerVisible,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_LONGER_PROCESSING_NOTICE_BANNER_VISIBLE: {
      return {
        ...state,
        isLongerProcessingNoticeBannerVisible: action.isLongerProcessingNoticeBannerVisible,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_VA_ENABLED: {
      return {
        ...state,
        isVAEnabled: action.isVAEnabled,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_TRANSFER_INFO: {
      return {
        ...state,
        transferInfo: action.transferInfo,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_DASHBOARD_BANNERS: {
      return {
        ...state,
        dashboardBanners: action.dashboardBanners,
      }
    }

    case LANDING_PAGE_ACTIONS.SET_IS_DASHBOARD_BANNER_MANAGEMENT_ENABLED: {
      return {
        ...state,
        isDashboardBannerManagementEnabled: action.isDashboardBannerManagementEnabled,
      }
    }

    default:
      return state
  }
}
